{
  "toasts": {
    "logoUpdated": "Logo updated successfully!",
    "logoUploadError": "Failed to upload logo",
    "logoRemoved": "Logo removed",
    "logoRemoveError": "Failed to remove logo",
    "bannerCreated": "Banner created successfully!",
    "bannerCreateError": "Failed to create banner",
    "bannerUpdated": "Banner updated!",
    "bannerUpdateError": "Failed to update banner",
    "bannerDeleted": "Banner deleted!",
    "bannerDeleteError": "Failed to delete banner",
    "menuItemCreated": "Menu item created!",
    "menuItemCreateError": "Failed to create menu item",
    "menuItemUpdated": "Menu item updated!",
    "menuItemUpdateError": "Failed to update menu item",
    "menuItemDeleted": "Menu item deleted!",
    "menuItemDeleteError": "Failed to delete menu item",
    "settingsUpdated": "Settings updated!",
    "settingsUpdateError": "Failed to update settings"
  },
  "branding": {
    "toasts": {
      "saveError": "Could not save.",
      "saved": "Branding updated. Students already see the change.",
      "reset": "Branding restored to default."
    },
    "loading": "Loading…",
    "title": "Branding",
    "subtitle": "How your members area looks to students.",
    "logo": {
      "title": "Logo",
      "description": "Shown at the top of the menu and on the sign-in screen. JPG, PNG, SVG or WEBP, up to 2MB."
    },
    "banner": {
      "title": "Sign-in image",
      "description": "Fills the panel next to the sign-in form. JPG, PNG or WEBP, up to 5MB. Without an image, the Xtreed brand is shown."
    },
    "favicon": {
      "title": "Favicon",
      "description": "Browser tab icon. ICO, PNG or SVG, up to 1MB."
    },
    "colors": {
      "title": "Colors",
      "description": "The primary color is used for buttons, links and highlights.",
      "primary": "Primary color",
      "secondary": "Secondary color",
      "hex": "{{label}} in hexadecimal"
    },
    "texts": {
      "title": "Texts",
      "welcome": "Welcome greeting",
      "welcomePlaceholder": "Welcome",
      "footer": "Footer text",
      "footerPlaceholder": "© Your school"
    },
    "save": "Save",
    "resetConfirm": "This clears the logo, sign-in image, favicon and colors. Continue?",
    "reset": "Restore defaults",
    "image": {
      "uploaded": "{{name}} updated.",
      "uploadError": "Could not upload {{nameLower}}.",
      "uploading": "Uploading…",
      "choose": "Choose file",
      "preview": "Preview: {{name}}",
      "empty": "No file uploaded"
    },
    "theme": {
      "title": "Theme",
      "description": "Choose whether the student area is light, dark, or each student picks.",
      "modes": {
        "STUDENT_CHOICE": "Student chooses (light or dark)",
        "LIGHT": "Always light",
        "DARK": "Always dark"
      }
    }
  },
  "customizationForm": {
    "validation": {
      "invalidHex": "Color must be a valid hexadecimal",
      "welcomeRequired": "Welcome text is required",
      "footerRequired": "Footer text is required"
    },
    "tabs": {
      "branding": "Brand",
      "colors": "Colors",
      "content": "Content"
    },
    "uploading": "Uploading...",
    "loaded": "Loaded",
    "loadedFeminine": "Loaded",
    "logo": {
      "title": "Logo",
      "description": "Upload the platform logo (JPG, PNG, SVG - max. 2MB)",
      "url": "Logo URL",
      "upload": "Upload logo",
      "preview": "Logo preview"
    },
    "banner": {
      "title": "Sign-in image",
      "description": "Fills the panel next to the sign-in form (JPG, PNG or WEBP — max. 5MB). Without an image, the Xtreed brand is shown.",
      "url": "Image URL",
      "upload": "Upload image",
      "preview": "Sign-in image preview"
    },
    "favicon": {
      "title": "Favicon",
      "description": "Icon shown in the browser tab (ICO, PNG - max. 1MB)",
      "url": "Favicon URL",
      "upload": "Upload favicon",
      "preview": "Favicon preview"
    },
    "colors": {
      "title": "Color scheme",
      "description": "Set the main platform colors",
      "primary": "Primary color",
      "primaryHint": "Main color for buttons and active elements",
      "secondary": "Secondary color",
      "secondaryHint": "Color for accents and secondary elements",
      "preview": "Color preview",
      "primaryShort": "Primary",
      "secondaryShort": "Secondary"
    },
    "texts": {
      "title": "Custom texts",
      "description": "Customize texts shown on the platform",
      "welcome": "Welcome text",
      "welcomePlaceholder": "Welcome to Xtreed",
      "welcomeHint": "Text shown on the home page",
      "footer": "Footer text",
      "footerPlaceholder": "© 2024 Xtreed. All rights reserved.",
      "footerHint": "Text shown in the footer of every page"
    },
    "actions": {
      "reset": "Restore defaults",
      "saving": "Saving...",
      "save": "Save changes"
    },
    "preview": {
      "title": "Live preview",
      "description": "See how the platform will look",
      "nav": {
        "courses": "Courses",
        "tracks": "Tracks",
        "profile": "Profile"
      },
      "heroSubtitle": "Learn the most modern technologies on the market",
      "start": "Get started",
      "learnMore": "Learn more",
      "featuredCourse": "Featured course",
      "sampleCourse": "React from Zero to Pro",
      "popularTrack": "Popular track",
      "platformStudent": "Platform student"
    },
    "palette": {
      "title": "Color palette"
    }
  },
  "cms": {
    "positions": {
      "home": "Home",
      "sidebar": "Sidebar",
      "header": "Header"
    },
    "title": "Customization",
    "subtitle": "Manage the platform banners, menus and sections",
    "tabs": {
      "banners": "Banners",
      "menu": "Menu",
      "sections": "Home sections",
      "support": "Support"
    },
    "actions": {
      "delete": "Delete",
      "activate": "Activate",
      "deactivate": "Deactivate"
    },
    "status": {
      "inactive": "Inactive"
    },
    "banners": {
      "title": "Banners",
      "description": "Banners are shown on the student dashboard. Multiple banners create an automatic carousel.",
      "new": "New banner",
      "create": "Create banner",
      "fallbackTitle": "Banner",
      "untitled": "Untitled banner",
      "noLink": "No destination link",
      "emptyTitle": "No banners",
      "emptyDescription": "Add banners to show on the student dashboard",
      "deleteTitle": "Delete banner",
      "deleteDescription": "Are you sure you want to delete this banner?"
    },
    "menu": {
      "title": "Custom menu",
      "description": "Add custom links to the student sidebar menu",
      "new": "New item",
      "create": "Create item",
      "external": "External",
      "noUrl": "No URL",
      "emptyTitle": "No menu items",
      "emptyDescription": "Add links to the student sidebar menu",
      "preview": "Menu preview",
      "previewLinks": "Links",
      "deleteTitle": "Delete menu item",
      "deleteDescription": "Are you sure you want to delete this menu item?"
    },
    "sections": {
      "description": "Organize courses into sections on the student home page"
    },
    "support": {
      "title": "WhatsApp support",
      "description": "Configure the support button shown to students",
      "cardTitle": "Support WhatsApp",
      "active": "Support enabled",
      "inactive": "Support disabled",
      "number": "WhatsApp number",
      "numberPlaceholder": "15551234567",
      "numberHint": "Format: country code + area code + number (e.g. 15551234567)",
      "message": "Automatic message",
      "messagePlaceholder": "Hi! I need help with...",
      "messageHint": "Pre-filled message when WhatsApp opens",
      "saving": "Saving...",
      "save": "Save settings",
      "activeDescription": "The WhatsApp button will appear in the bottom-right corner for students.",
      "inactiveDescription": "Enable support to show the WhatsApp button to students."
    }
  }
}
